import React, { useState, useEffect, useMemo, useRef } from "react";
import { Modal, Button, Form, Row, Col, Table } from "react-bootstrap";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_FABRICS } from "../../apollo/fabric/query";
import { SHOP_SIZES } from "../../apollo/setting_apollo/query";
import { CREATE_MANY_ORDER_WITH_ORDER_GROUP_CUSTOM } from "../../apollo/order/mutation";
import { GET_USER_CONFIRM } from "../../apollo/userconfirm/query";
import { GET_PRESIGN_URL } from "../../apollo/presignUrl/query";
import { GET_REWARDS_V2 } from "../../apollo/reward/Query";
import { LaoAddress } from "../../const/laoAddress";
import Swal from "sweetalert2";
import CreateCustomerModal from "./CreateCustomerModal";
import { FaCheckCircle, FaCamera } from "react-icons/fa";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { NumericFormat } from "react-number-format";

const CreateOrderModal = ({ show, onHide, shopId, products }) => {
  const paySlipFileRef = useRef(null);
  const [formData, setFormData] = useState({
    code: "",
    firstName: "",
    lastName: "",
    phone: "",
    village: "",
    district: "",
    province: "",
    receiveDate: "",
    logistic: "",
    payment: "TRANSFER",
    paymentType: "FULL",
    receivedMoney: "",
    paySlip: "",
  });

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerSearchTerm, setCustomerSearchTerm] = useState("");
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);

  const [getUserConfirm, { data: getuserConfirmData }] = useLazyQuery(GET_USER_CONFIRM, { fetchPolicy: "cache-and-network" });
  
  useEffect(() => {
    if (showCustomerDropdown && shopId) {
      getUserConfirm({
        variables: {
          where: {
            shop: shopId,
            isDeleted: false,
            ...(customerSearchTerm ? { searchKeyWord: customerSearchTerm } : {})
          },
          limit: 10,
          orderBy: "createdAt_DESC"
        }
      });
    }
  }, [customerSearchTerm, showCustomerDropdown, shopId, getUserConfirm]);

  const customerList = getuserConfirmData?.userconfirms?.data || [];

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [imagePreviewSrc, setImagePreviewSrc] = useState("");
  const [paySlipPreviewSrc, setPaySlipPreviewSrc] = useState("");
  const [isUploadingPaySlip, setIsUploadingPaySlip] = useState(false);

  const [getFabrics, { data: fabricData }] = useLazyQuery(GET_FABRICS, {
    fetchPolicy: "network-only",
  });
  const [getShopSizes, { data: shopSizeData }] = useLazyQuery(SHOP_SIZES, {
    fetchPolicy: "network-only",
  });
  const [getPresignUrl] = useLazyQuery(GET_PRESIGN_URL, {
    fetchPolicy: "network-only",
  });
  const [getRewards, { data: rewardsData, loading: rewardsLoading }] = useLazyQuery(GET_REWARDS_V2, {
    fetchPolicy: "cache-and-network",
  });

  const [createOrdergroupCustomize, { loading: creatingOrder }] = useMutation(
    CREATE_MANY_ORDER_WITH_ORDER_GROUP_CUSTOM
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (show && shopId) {
      getFabrics({ variables: { where: { shop: shopId, isDeleted: false } } });
      getShopSizes({ variables: { shop: shopId } });
      getRewards();
    }
  }, [show, shopId, getFabrics, getShopSizes, getRewards]);

  useEffect(() => {
    if (!show) {
      setFormData({
        code: "",
        firstName: "",
        lastName: "",
        phone: "",
        village: "",
        district: "",
        province: "",
        receiveDate: "",
        logistic: "",
        payment: "TRANSFER",
        paymentType: "FULL",
        receivedMoney: "",
        paySlip: "",
      });
      if (typeof paySlipPreviewSrc === "string" && paySlipPreviewSrc.startsWith("blob:")) {
        try {
          URL.revokeObjectURL(paySlipPreviewSrc);
        } catch (_) {}
      }
      setPaySlipPreviewSrc("");
      setIsUploadingPaySlip(false);
      setSelectedProducts([]);
      setSearchTerm("");
      setShowDropdown(false);
      setSelectedCustomer(null);
      setCustomerSearchTerm("");
      setShowCustomerDropdown(false);
    }
  }, [show, paySlipPreviewSrc]);

  const fabrics = fabricData?.fabrics?.data || [];
  const shopSizes = shopSizeData?.shopSizes || [];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleProductSelect = (product) => {
    // Check if the product has isPrinted directly or inside a nested product object (for variants)
    const isPrintedStatus = product.isPrinted === true || product.product?.isPrinted === true;
    console.log("Selected Product:", product);
    console.log("isPrintedStatus:", isPrintedStatus);

    setSelectedProducts([
      ...selectedProducts,
      {
        product: { ...product, isPrinted: isPrintedStatus },
        fabricId: "",
        sizeQuantities: {},
        quantity: 1,
        orderDetail: "",
        elementImages: [],
        isUploadingElementImages: false,
        totalPriceOverride: "",
        discountAmount: "",
        freeGifts: [],
      },
    ]);
    setShowDropdown(false);
    setSearchTerm(""); // Clear search term to allow searching another product easily
  };

  const handleRemoveProduct = (index) => {
    const newProducts = [...selectedProducts];
    const toRemove = newProducts[index];
    if (toRemove?.elementImages?.length) {
      toRemove.elementImages.forEach((img) => {
        if (typeof img?.previewSrc === "string" && img.previewSrc.startsWith("blob:")) {
          try {
            URL.revokeObjectURL(img.previewSrc);
          } catch (_) {}
        }
      });
    }
    newProducts.splice(index, 1);
    setSelectedProducts(newProducts);
  };

  const handleElementImageChange = async (productIndex, event) => {
    const files = Array.from(event?.target?.files || []);
    if (files.length === 0) return;

    setSelectedProducts((prev) => {
      const next = [...prev];
      if (!next[productIndex]) return prev;
      next[productIndex] = { ...next[productIndex], isUploadingElementImages: true };
      return next;
    });

    try {
      const uploaded = await Promise.all(
        files.map(async (file, idx) => {
          const ext = (file?.name || "").split(".").pop() || "png";
          const filename = `element_${Date.now()}_${uuidv4()}_${idx}.${ext}`;
          const pre = await getPresignUrl({ variables: { name: filename } });
          const url = pre?.data?.preSignedUrl?.url;
          if (!url) throw new Error("Failed to get upload url");

          try {
            await axios.put(url, file, {
              headers: {
                "Content-Type": "file/*; image/*",
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              },
            });
          } catch (uploadError) {
            const status = uploadError?.response?.status;
            const message =
              status === 403
                ? "403 Forbidden (ລາຍເຊັນ/ນະໂຍບາຍ S3 ບໍ່ກົງ)"
                : uploadError?.message || "Upload failed";
            throw new Error(message);
          }

          const previewSrc = URL.createObjectURL(file);
          return { image: filename, previewSrc, detail: "" };
        })
      );

      setSelectedProducts((prev) => {
        const next = [...prev];
        if (!next[productIndex]) return prev;
        const current = Array.isArray(next[productIndex].elementImages) ? next[productIndex].elementImages : [];
        next[productIndex] = {
          ...next[productIndex],
          elementImages: [...current, ...uploaded],
        };
        return next;
      });
    } catch (error) {
      Swal.fire("ຜິດພາດ", error?.message || "ອັບໂຫຼດບໍ່ສຳເລັດ", "error");
    } finally {
      setSelectedProducts((prev) => {
        const next = [...prev];
        if (!next[productIndex]) return prev;
        next[productIndex] = { ...next[productIndex], isUploadingElementImages: false };
        return next;
      });
      if (event?.target) event.target.value = "";
    }
  };

  const removePaySlip = () => {
    setFormData((prev) => ({ ...prev, paySlip: "" }));
    if (typeof paySlipPreviewSrc === "string" && paySlipPreviewSrc.startsWith("blob:")) {
      try {
        URL.revokeObjectURL(paySlipPreviewSrc);
      } catch (_) {}
    }
    setPaySlipPreviewSrc("");
  };

  const handlePaySlipChange = async (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    setIsUploadingPaySlip(true);
    try {
      const ext = (file?.name || "").split(".").pop() || "png";
      const filename = `payslip_${Date.now()}_${uuidv4()}.${ext}`;
      const pre = await getPresignUrl({ variables: { name: filename } });
      const url = pre?.data?.preSignedUrl?.url;
      if (!url) throw new Error("Failed to get upload url");

      await axios.put(url, file, {
        headers: {
          "Content-Type": "file/*; image/*",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
          "Access-Control-Allow-Headers":
            "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
        },
      });

      const previewSrc = URL.createObjectURL(file);
      setFormData((prev) => ({ ...prev, paySlip: filename }));
      if (typeof paySlipPreviewSrc === "string" && paySlipPreviewSrc.startsWith("blob:")) {
        try {
          URL.revokeObjectURL(paySlipPreviewSrc);
        } catch (_) {}
      }
      setPaySlipPreviewSrc(previewSrc);
    } catch (error) {
      Swal.fire("ຜິດພາດ", error?.message || "ອັບໂຫຼດບໍ່ສຳເລັດ", "error");
      setFormData((prev) => ({ ...prev, paySlip: "" }));
      if (typeof paySlipPreviewSrc === "string" && paySlipPreviewSrc.startsWith("blob:")) {
        try {
          URL.revokeObjectURL(paySlipPreviewSrc);
        } catch (_) {}
      }
      setPaySlipPreviewSrc("");
    } finally {
      setIsUploadingPaySlip(false);
      if (event?.target) event.target.value = "";
    }
  };

  const removeElementImage = (productIndex, imageIndex) => {
    setSelectedProducts((prev) => {
      const next = [...prev];
      const sp = next[productIndex];
      if (!sp) return prev;
      const list = Array.isArray(sp.elementImages) ? [...sp.elementImages] : [];
      const removed = list[imageIndex];
      if (typeof removed?.previewSrc === "string" && removed.previewSrc.startsWith("blob:")) {
        try {
          URL.revokeObjectURL(removed.previewSrc);
        } catch (_) {}
      }
      list.splice(imageIndex, 1);
      next[productIndex] = { ...sp, elementImages: list };
      return next;
    });
  };

  const updateElementImageDetail = (productIndex, imageIndex, value) => {
    setSelectedProducts((prev) => {
      const next = [...prev];
      const sp = next[productIndex];
      if (!sp) return prev;
      const list = Array.isArray(sp.elementImages) ? [...sp.elementImages] : [];
      if (!list[imageIndex]) return prev;
      list[imageIndex] = { ...list[imageIndex], detail: value };
      next[productIndex] = { ...sp, elementImages: list };
      return next;
    });
  };

  const addFreeGiftRow = (productIndex) => {
    setSelectedProducts((prev) => {
      const next = [...prev];
      const sp = next[productIndex];
      if (!sp) return prev;
      const current = Array.isArray(sp.freeGifts) ? sp.freeGifts : [];
      const allowedFree = Number(
        (rewardSummary?.lineApplications || []).find((x) => x.index === productIndex)?.amountFree || 0,
      );
      const currentSum = current.reduce((sum, row) => sum + (parseInt(row?.qty) || 0), 0);
      if (allowedFree > 0 && currentSum >= allowedFree) {
        Swal.fire("ແຈ້ງເຕືອນ", `ຈຳນວນແຖມຄົບແລ້ວ (${currentSum}/${allowedFree})`, "warning");
        return prev;
      }
      next[productIndex] = {
        ...sp,
        freeGifts: [...current, { sizeId: "", size: "", qty: "" }],
      };
      return next;
    });
  };

  const removeFreeGiftRow = (productIndex, rowIndex) => {
    setSelectedProducts((prev) => {
      const next = [...prev];
      const sp = next[productIndex];
      if (!sp) return prev;
      const current = Array.isArray(sp.freeGifts) ? [...sp.freeGifts] : [];
      current.splice(rowIndex, 1);
      next[productIndex] = { ...sp, freeGifts: current };
      return next;
    });
  };

  const updateFreeGiftRow = (productIndex, rowIndex, patch) => {
    setSelectedProducts((prev) => {
      const next = [...prev];
      const sp = next[productIndex];
      if (!sp) return prev;
      const current = Array.isArray(sp.freeGifts) ? [...sp.freeGifts] : [];
      if (!current[rowIndex]) return prev;
      const allowedFree = Number(
        (rewardSummary?.lineApplications || []).find((x) => x.index === productIndex)?.amountFree || 0,
      );
      const nextRow = { ...current[rowIndex], ...patch };
      const otherSum = current.reduce((sum, row, idx) => {
        if (idx === rowIndex) return sum;
        return sum + (parseInt(row?.qty) || 0);
      }, 0);
      if (Object.prototype.hasOwnProperty.call(patch || {}, "qty")) {
        const raw = patch?.qty;
        if (raw === "" || raw === null || raw === undefined) {
          nextRow.qty = "";
        } else {
          const desired = Math.max(parseInt(raw) || 0, 0);
          const remaining = Math.max(allowedFree - otherSum, 0);
          if (desired > remaining) {
            Swal.fire("ແຈ້ງເຕືອນ", `ປ້ອນເກີນຈຳນວນແຖມ, ຍັງເຫຼືອ ${remaining} ຊິ້ນ`, "warning");
          }
          nextRow.qty = Math.min(desired, remaining);
        }
      }
      current[rowIndex] = nextRow;
      next[productIndex] = { ...sp, freeGifts: current };
      return next;
    });
  };

  const handleProductChange = (index, field, value) => {
    const newProducts = [...selectedProducts];
    newProducts[index][field] = value;
    setSelectedProducts(newProducts);
  };

  const handleProductSizeChange = (index, sizeId, value) => {
    const newProducts = [...selectedProducts];
    newProducts[index].sizeQuantities = {
      ...newProducts[index].sizeQuantities,
      [sizeId]: value === "" ? "" : parseInt(value) || 0,
    };
    setSelectedProducts(newProducts);
  };

  const toggleProductSize = (index, sizeId) => {
    const newProducts = [...selectedProducts];
    const sizeQuantities = { ...newProducts[index].sizeQuantities };
    
    if (sizeQuantities.hasOwnProperty(sizeId)) {
      delete sizeQuantities[sizeId];
    } else {
      sizeQuantities[sizeId] = "";
    }
    
    newProducts[index].sizeQuantities = sizeQuantities;
    setSelectedProducts(newProducts);
  };

  const filteredProducts = products?.filter((p) => {
    const isSelected = selectedProducts.some((sp) => sp.product.id === p.id);
    return !isSelected && p.name?.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const getDiscountAmount = (sp) => {
    const raw = sp?.discountAmount;
    if (raw === "" || raw === null || raw === undefined) return 0;
    const normalized = typeof raw === "string" ? raw.replace(/,/g, "").trim() : raw;
    const num = typeof normalized === "number" ? normalized : parseFloat(normalized);
    if (!Number.isFinite(num) || num <= 0) return 0;
    return num;
  };

  const getTotalPriceOverride = (sp) => {
    const raw = sp?.totalPriceOverride;
    if (raw === "" || raw === null || raw === undefined) return undefined;
    const normalized = typeof raw === "string" ? raw.replace(/,/g, "").trim() : raw;
    const num = typeof normalized === "number" ? normalized : parseFloat(normalized);
    if (!Number.isFinite(num) || num < 0) return undefined;
    return num;
  };

  const calculateBaseProductPrice = (sp) => {
    if (sp.product.isPrinted) {
      const selectedFabric = fabrics.find((f) => f.id === sp.fabricId);
      const fabricPrice = selectedFabric ? selectedFabric.price : 0;
      let totalQuantity = 0;
      if (sp.sizeQuantities) {
        Object.values(sp.sizeQuantities).forEach((q) => {
          totalQuantity += parseInt(q) || 0;
        });
      }
      return totalQuantity * fabricPrice;
    }
    return (parseInt(sp.quantity) || 0) * (sp.product.price || 0);
  };

  const calculateProductPrice = (sp) => {
    const override = getTotalPriceOverride(sp);
    const baseTotal = override !== undefined ? override : calculateBaseProductPrice(sp);
    const discount = getDiscountAmount(sp);
    return Math.max(baseTotal - discount, 0);

  };

  const calculateTotalOrderPrice = () => {
    return selectedProducts.reduce((total, sp) => total + calculateProductPrice(sp), 0);
  };

  const rewards = rewardsData?.getRewardsV2?.data || [];

  const rewardCandidates = useMemo(() => {
    return (rewards || []).filter((r) => {
      if (!r) return false;
      if (r?.isDeleted) return false;
      if (r?.shop?.id && shopId && r.shop.id !== shopId) return false;
      const platform = (r?.platform || "ALL").toString();
      if (platform !== "ALL" && platform !== "POS") return false;
      return true;
    });
  }, [rewards, shopId]);

  const rewardSummary = useMemo(() => {
    const lines = (selectedProducts || []).map((sp) => {
      const productIds = [
        sp?.product?.stock?.id,
        sp?.product?.id,
        sp?.product?._id,
        sp?.product?.product?.id,
        sp?.product?.product?._id,
      ]
        .map((v) => (v ? String(v) : ""))
        .filter(Boolean);

      const categoryIds = [
        sp?.product?.product?.category?.id,
        sp?.product?.category?.id,
        sp?.product?.stock?.category?.id,
        sp?.product?.product?.category?._id,
      ]
        .map((v) => (v ? String(v) : ""))
        .filter(Boolean);

      const qty = sp?.product?.isPrinted
        ? Object.values(sp?.sizeQuantities || {}).reduce((sum, q) => sum + (parseInt(q) || 0), 0)
        : (parseInt(sp?.quantity) || 0);
      const amount = Number(calculateProductPrice(sp) || 0);
      return { productIds, categoryIds, qty, amount };
    });

    const totalQty = lines.reduce((sum, l) => sum + (l.qty || 0), 0);
    const totalAmount = lines.reduce((sum, l) => sum + (l.amount || 0), 0);

    const matchReward = (reward) => {
      const nowMs = Date.now();
      const startMs = reward?.startDate ? new Date(reward.startDate).getTime() : NaN;
      const endMs = reward?.endDate ? new Date(reward.endDate).getTime() : NaN;
      const hasStart = !Number.isNaN(startMs);
      const hasEnd = !Number.isNaN(endMs);
      const isExpired = hasEnd && nowMs > endMs;

      let isActive = true;
      let inactiveReason = "";
      if (reward?.status && reward.status !== "USABLE") {
        isActive = false;
        inactiveReason = "ປິດໃຊ້ງານ";
      } else if (Number(reward?.remainUser) === 0) {
        isActive = false;
        inactiveReason = "ເຄື່ອງໝົດ";
      } else if (hasStart && nowMs < startMs) {
        isActive = false;
        inactiveReason = "ຍັງບໍ່ເລີ່ມ";
      } else if (isExpired) {
        isActive = false;
        inactiveReason = "ໝົດອາຍຸ";
      }

      const applyType = (reward?.applyType || "ALL").toString();
      const applicableProductIds = (reward?.applicableProducts || []).map((p) => (p?.id || p || "").toString()).filter(Boolean);
      const applicableCategoryIds = (reward?.applicableCategories || []).map((c) => (c?.id || c || "").toString()).filter(Boolean);

      let relevant = lines;
      if (applyType === "SPECIFIC_PRODUCTS") {
        relevant = lines.filter((l) => l.productIds?.some((id) => applicableProductIds.includes(id)));
      } else if (applyType === "SPECIFIC_CATEGORIES") {
        relevant = lines.filter((l) => l.categoryIds?.some((id) => applicableCategoryIds.includes(id)));
      }

      const isLinked = applyType === "ALL" ? true : relevant.length > 0;
      const qty = relevant.reduce((sum, l) => sum + (l.qty || 0), 0);
      const amount = relevant.reduce((sum, l) => sum + (l.amount || 0), 0);
      const minQty = Number(reward?.minimumOrderQuantity || 0) || 0;
      const minAmount = Number(reward?.minimumOrderAmount || 0) || 0;
      const qtyOk = minQty <= 0 ? true : qty >= minQty;
      const amountOk = minAmount <= 0 ? true : amount >= minAmount;
      const isEligible = isLinked && isActive && qtyOk && amountOk;

      return { isLinked, isEligible, qty, amount, minQty, minAmount, applyType, isActive, inactiveReason, isExpired };
    };

    const related = rewardCandidates
      .map((r) => ({ reward: r, ...matchReward(r) }))
      .filter((x) => x.isLinked && !x.isExpired);

    const eligible = related.filter((x) => x.isEligible);
    const notYet = related.filter((x) => !x.isEligible);

    const itemEligible = eligible.filter((x) => x?.reward?.rewardType === "ITEM");
    const discountEligible = eligible.filter((x) => x?.reward?.rewardType === "DISCOUNT");

    const lineApplications = lines.map((line, idx) => {
      const freeFromRewards = itemEligible.reduce((sum, entry) => {
        const reward = entry.reward || {};
        const minQty = Number(reward?.minimumOrderQuantity || 0) || 0;
        const freeQty = Number(reward?.freeItemQuantity || 0) || 0;
        if (minQty <= 0 || freeQty <= 0) return sum;

        const applyType = (reward?.applyType || "ALL").toString();
        const applicableProductIds = (reward?.applicableProducts || []).map((p) => (p?.id || p || "").toString()).filter(Boolean);
        const applicableCategoryIds = (reward?.applicableCategories || []).map((c) => (c?.id || c || "").toString()).filter(Boolean);

        const isTargetLine =
          applyType === "ALL" ||
          (applyType === "SPECIFIC_PRODUCTS" && line.productIds?.some((id) => applicableProductIds.includes(id))) ||
          (applyType === "SPECIFIC_CATEGORIES" && line.categoryIds?.some((id) => applicableCategoryIds.includes(id)));

        if (!isTargetLine) return sum;
        return sum + Math.floor((line.qty || 0) / minQty) * freeQty;
      }, 0);

      return { index: idx, amountFree: freeFromRewards };
    });

    const totalFreeQty = lineApplications.reduce((sum, x) => sum + (x.amountFree || 0), 0);

    const discountAmount = discountEligible.reduce((sum, entry) => {
      const reward = entry.reward || {};
      const baseAmount = Number(entry.amount || 0) || 0;
      const percent = Number(reward?.percent || 0) || 0;
      const maxDiscountAmount = Number(reward?.maxDiscountAmount || 0) || 0;
      let discount = 0;
      if (percent > 0) {
        discount = (baseAmount * percent) / 100;
      } else if (maxDiscountAmount > 0) {
        discount = maxDiscountAmount;
      }
      if (maxDiscountAmount > 0) {
        discount = Math.min(discount, maxDiscountAmount);
      }
      return sum + discount;
    }, 0);

    return { totalQty, totalAmount, eligible, notYet, lineApplications, totalFreeQty, discountAmount };
  }, [selectedProducts, rewardCandidates, calculateProductPrice]);

  const isElementImagesUploading = selectedProducts.some((sp) => sp?.isUploadingElementImages);
  const totalOrderPricePreview = calculateTotalOrderPrice();
  const discountAmountAppliedPreview = Number(rewardSummary?.discountAmount || 0) || 0;
  const totalAfterDiscountPreview = Math.max(totalOrderPricePreview - discountAmountAppliedPreview, 0);
  const receivedMoneyPreview = parseFloat(formData.receivedMoney) || 0;
  const changePreview = Math.max(receivedMoneyPreview - totalAfterDiscountPreview, 0);
  const outstandingPreview = Math.max(totalAfterDiscountPreview - receivedMoneyPreview, 0);

  const handleSubmit = async () => {
    if (selectedProducts.length === 0) {
      Swal.fire("ແຈ້ງເຕືອນ", "ກະລຸນາເລືອກສິນຄ້າ", "warning");
      return;
    }
    if (isElementImagesUploading) {
      Swal.fire("ແຈ້ງເຕືອນ", "ກຳລັງອັບໂຫຼດຮູບອົງປະກອບ, ກະລຸນາລໍຖ້າ...", "warning");
      return;
    }
    if (isUploadingPaySlip) {
      Swal.fire("ແຈ້ງເຕືອນ", "ກຳລັງອັບໂຫຼດສະລິບ, ກະລຸນາລໍຖ້າ...", "warning");
      return;
    }

    if (formData.paymentType === "FULL" && receivedMoneyPreview < totalAfterDiscountPreview) {
      Swal.fire("ແຈ້ງເຕືອນ", `ຈ່າຍເຕັມຕ້ອງຮັບເງິນຢ່າງນ້ອຍ ${totalAfterDiscountPreview.toLocaleString()}`, "warning");
      return;
    }
    if (formData.paymentType === "DEPOSIT") {
      if (receivedMoneyPreview <= 0) {
        Swal.fire("ແຈ້ງເຕືອນ", "ກະລຸນາປ້ອນຈຳນວນເງິນມັດຈຳ", "warning");
        return;
      }
      if (receivedMoneyPreview >= totalAfterDiscountPreview) {
        Swal.fire("ແຈ້ງເຕືອນ", "ຖ້າຈ່າຍຄົບແລ້ວ ກະລຸນາເລືອກ 'ຈ່າຍເຕັມ'", "warning");
        return;
      }
      if (formData.payment === "TRANSFER" && !formData.paySlip) {
        Swal.fire("ແຈ້ງເຕືອນ", "ກະລຸນາອັບໂຫຼດຮູບສະລິບການໂອນ", "warning");
        return;
      }
    }

    try {
      const freeMap = new Map((rewardSummary?.lineApplications || []).map((x) => [x.index, x.amountFree || 0]));
      const mismatchIndex = selectedProducts.findIndex((sp, idx) => {
        const allowedFree = Number(freeMap.get(idx) || 0) || 0;
        if (allowedFree <= 0) return false;
        const entered = (sp?.freeGifts || []).reduce((sum, row) => sum + (parseInt(row?.qty) || 0), 0);
        return entered !== allowedFree;
      });
      if (mismatchIndex !== -1) {
        const sp = selectedProducts[mismatchIndex];
        const allowedFree = Number(freeMap.get(mismatchIndex) || 0) || 0;
        const entered = (sp?.freeGifts || []).reduce((sum, row) => sum + (parseInt(row?.qty) || 0), 0);
        const name =
          [
            sp?.product?.productName,
            sp?.product?.name,
            sp?.product?.product?.name,
            sp?.product?.stock?.name,
            sp?.product?.stock?.productName,
          ]
            .map((v) => (typeof v === "string" ? v.trim() : ""))
            .find(Boolean) || "-";
        Swal.fire("ແຈ້ງເຕືອນ", `ກະລຸນາປ້ອນຈຳນວນແຖມໃຫ້ຄົບ ${allowedFree} ຊິ້ນ (ປ້ອນແລ້ວ ${entered})\nສິນຄ້າ: ${name}`, "warning");
        return;
      }

      const orders = selectedProducts.map((p, idx) => {
        let orderDetail = p.orderDetail || "";
        let shopSize = "";
        let fabric = "";
        const productName = [
          p?.product?.productName,
          p?.product?.name,
          p?.product?.product?.name,
          p?.product?.stock?.name,
          p?.product?.stock?.productName,
        ]
          .map((v) => (typeof v === "string" ? v.trim() : ""))
          .find(Boolean) || "";
        
        let amount = p.product.isPrinted
          ? Object.values(p.sizeQuantities).reduce(
              (acc, q) => acc + (parseInt(q) || 0),
              0
            )
          : parseInt(p.quantity) || 1;
        let price = p.product.isPrinted
          ? fabrics.find((f) => f.id === p.fabricId)?.price || 0
          : p.product.price || 0;

        if (p.product.isPrinted) {
          const sizeNotes = Object.entries(p.sizeQuantities)
            .filter(([szId, q]) => parseInt(q) > 0)
            .map(
              ([szId, q]) =>
                `${shopSizes.find((s) => s.id === szId)?.value || szId}(${q})`
            )
            .join(", ");
          
          shopSize = sizeNotes;
            
          const fabricName =
            fabrics.find((f) => f.id === p.fabricId)?.name || "";
            
          fabric = fabricName;
        }

        const overrideTotalPrice = getTotalPriceOverride(p);
        const discountAmount = getDiscountAmount(p);
        const totalPrice = calculateProductPrice(p);
        if (overrideTotalPrice !== undefined || discountAmount > 0) {
          price = amount > 0 ? totalPrice / amount : 0;
        }

        return {
          product: p.product.id,
          stock: p.product.id, // V4 usually expects stock to be populated
          productVariant: p.product.productVariant ?? null, // Match Carts.js
          productName,
          amount: amount,
          amountFree: freeMap.get(idx) || 0,
          price: price,
          totalPrice: totalPrice,
          totalPriceBaht: 0,
          totalPriceUsd: 0,
          orderDetail: orderDetail,
          shopSize: shopSize || null,
          fabric: fabric || null,
          fabricId: p.fabricId || null,
          ...(p?.elementImages?.length
            ? {
                imagesElement: p.elementImages
                  .filter((el) => typeof el?.image === "string" && el.image.trim())
                  .map((el) => ({
                    image: el.image.trim(),
                    detail: typeof el?.detail === "string" && el.detail.trim() ? el.detail.trim() : null,
                  })),
              }
            : {}),
          ...(p?.freeGifts?.length
            ? {
                freeGifts: p.freeGifts
                  .map((g) => ({
                    size: typeof g?.size === "string" ? g.size.trim() : "",
                    qty: Number(g?.qty || 0) || 0,
                  }))
                  .filter((g) => g.size && g.qty > 0),
              }
            : {}),
          currency: p.product.currency || "LAK",
          commissionPlatform: "POS", // Default fallback
          commissionType: null,
          commissionValue: 0,
        };
      });

      const totalOrderPrice = calculateTotalOrderPrice();
      const discountAmountApplied = Number(rewardSummary?.discountAmount || 0) || 0;
      const totalAfterDiscount = Math.max(totalOrderPrice - discountAmountApplied, 0);
      const totalAmount = orders.reduce((sum, order) => sum + order.amount, 0);
      const received = parseFloat(formData.receivedMoney) || 0;
      const debt = formData.paymentType === "FULL" ? 0 : Math.max(totalAfterDiscount - received, 0);
      const depositAmount = formData.paymentType === "FULL" ? totalAfterDiscount : received;
      const outstandingAmount = formData.paymentType === "FULL" ? 0 : debt;
      const depositStatus = formData.paymentType === "FULL" ? "PAID_FULL" : "DEPOSIT_PENDING";
      const change = received - totalAfterDiscount > 0 ? received - totalAfterDiscount : 0;
      const receiveDateIso = formData.receiveDate
        ? new Date(`${formData.receiveDate}T00:00:00.000Z`).toISOString()
        : null;

      const addressParts = [formData.village, formData.district, formData.province]
        .map((v) => (typeof v === "string" ? v.trim() : ""))
        .filter(Boolean);
      const addressText = addressParts.join(", ");
      const logisticName = typeof formData.logistic === "string" ? formData.logistic.trim() : "";
      const addressCf = logisticName && addressText ? `${logisticName} - ${addressText}` : (logisticName || addressText);
      const isPaymented = debt <= 0;
      const cash = formData.payment === "CASH" ? received : 0;
      const transfer = formData.payment === "TRANSFER" ? received : 0;

      const orderGroup = {
        shop: shopId,
        customerName: formData.firstName,
        customerLastName: formData.lastName,
        phone: formData.phone,
        village: formData.village,
        district: formData.district,
        province: formData.province,
        receiveDate: receiveDateIso,
        paymentDate: new Date().toISOString(),
        currency: "LAK",
        amount: totalAmount, // Total quantities across orders
        totalPrice: totalAfterDiscount,
        sumPrice: totalAfterDiscount,
        sumPriceBaht: 0,
        sumPriceUsd: 0,
        discount: 0,
        discountType: true,
        discountManual: discountAmountApplied,
        payment: formData.payment, 
        change: change,
        receivedMoney: received,
        isPaymented,
        depositAmount,
        outstandingAmount,
        depositStatus,
        ...(formData.paySlip ? { paySlip: formData.paySlip } : {}),
        ...(addressCf ? { addressCf } : {}),
        ...(logisticName ? { logistic: logisticName } : {}),
        cash,
        transfer,
        debt,
        ...(debt > 0 ? { status: "INDEBTED" } : {}),
        commissionPlatforms: "POS", // Default fallback
        ...(formData.code ? { code: formData.code } : {}),
        ...(selectedCustomer ? { userConfirm: selectedCustomer.id } : {}),
      };

      const payload = {
        orders,
        orderGroup,
      };

      console.log("Submit Order Payload (V4-like structure): ", payload);

      const res = await createOrdergroupCustomize({
        variables: { data: payload },
      });

      if (res.data?.createOrdergroupCustomize?.id) {
        Swal.fire("ສຳເລັດ", "ບັນທຶກອໍເດີສຳເລັດແລ້ວ", "success");
        onHide();
      }
    } catch (error) {
      console.error("Error creating order:", error);
      Swal.fire("ຜິດພາດ", "ບໍ່ສາມາດບັນທຶກອໍເດີໄດ້: " + error.message, "error");
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 18, fontWeight: "bold" }}>
          ສ້າງອໍເດີ
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group>
                <Form.Label>ລະຫັດອໍເດີ (Code) - <span className="text-muted" style={{fontSize: '12px'}}>ປ່ອຍຫວ່າງໄວ້ເພື່ອໃຫ້ລະບົບສ້າງອັດຕະໂນມັດ</span></Form.Label>
                <Form.Control
                  type="text"
                  name="code"
                  value={formData.code}
                  onChange={handleInputChange}
                  placeholder="ປ້ອນລະຫັດອໍເດີ (ຖ້າມີ)"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={12}>
              <Form.Group style={{ position: "relative" }}>
                <Form.Label>ຄົ້ນຫາລູກຄ້າ / ສະມາຊິກ (ເລືອກ ຫຼື ພິມຊື່ໃໝ່ໄດ້ເລີຍ)</Form.Label>
                <div className="d-flex">
                  <Form.Control
                    type="text"
                    placeholder="ຄົ້ນຫາຊື່ ຫຼື ເບີໂທລູກຄ້າ..."
                    value={customerSearchTerm}
                    onChange={(e) => {
                      setCustomerSearchTerm(e.target.value);
                      setShowCustomerDropdown(true);
                      // ຖ້າພິມຊື່ໃໝ່ ກໍໃຫ້ອັບເດດ firstName ໄປພ້ອມເລີຍ ແລະ clear selectedCustomer
                      setFormData({ ...formData, firstName: e.target.value });
                      if (selectedCustomer) setSelectedCustomer(null);
                    }}
                    onFocus={() => setShowCustomerDropdown(true)}
                  />
                  <Button
                    variant="outline-success"
                    className="ms-2"
                    style={{ whiteSpace: "nowrap" }}
                    onClick={() => {
                      setShowCreateCustomerModal(true);
                    }}
                  >
                    + ເພີ່ມລູກຄ້າ
                  </Button>
                </div>
                {showCustomerDropdown && customerList?.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      maxHeight: "200px",
                      overflowY: "auto",
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      zIndex: 1000,
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {customerList.map((c) => (
                      <div
                        key={c.id}
                        style={{
                          padding: "10px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onClick={() => {
                          setSelectedCustomer(c);
                          setCustomerSearchTerm(`${c.name || ""} ${c.lastname || ""}`.trim());
                          setFormData({
                            ...formData,
                            firstName: c.name || "",
                            lastName: c.lastname || "",
                            phone: c.phone || "",
                            province: c.address?.province || "",
                            district: c.address?.district || "",
                            village: c.address?.village || "",
                          });
                          setShowCustomerDropdown(false);
                        }}
                      >
                        {c.name} {c.lastname} {c.phone ? `(${c.phone})` : ""}
                      </div>
                    ))}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>ຊື່</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="ປ້ອນຊື່"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>ນາມສະກຸນ</Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="ປ້ອນນາມສະກຸນ"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>ເບີໂທ</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="ປ້ອນເບີໂທ"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>ວັນທີຮັບເຄື່ອງ</Form.Label>
                <Form.Control
                  type="date"
                  name="receiveDate"
                  value={formData.receiveDate}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>ແຂວງ</Form.Label>
                <Form.Control
                  as="select"
                  name="province"
                  value={formData.province}
                  onChange={(e) => {
                    setFormData({ ...formData, province: e.target.value, district: "" });
                  }}
                >
                  <option value="">--ເລືອກ--</option>
                  {LaoAddress.map((p, index) => (
                    <option key={"province" + index} value={p?.province_name}>
                      {p?.province_name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>ເມືອງ</Form.Label>
                <Form.Control
                  as="select"
                  name="district"
                  disabled={!formData.province}
                  value={formData.district}
                  onChange={handleInputChange}
                >
                  <option value="">--ເລືອກ--</option>
                  {formData.province &&
                    LaoAddress.find((f) => f.province_name === formData.province)?.district_list?.map((p, index) => (
                      <option key={"district" + index} value={p?.district}>
                        {p?.district}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>ບ້ານ</Form.Label>
                <Form.Control
                  type="text"
                  name="village"
                  value={formData.village}
                  onChange={handleInputChange}
                  placeholder="ປ້ອນບ້ານ"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>ຮູບແບບການຈ່າຍ</Form.Label>
                <Form.Control
                  as="select"
                  name="paymentType"
                  value={formData.paymentType}
                  onChange={(e) => {
                    const nextType = e.target.value;
                    setFormData((prev) => ({
                      ...prev,
                      paymentType: nextType,
                    }));
                  }}
                >
                  <option value="FULL">ຈ່າຍເຕັມ</option>
                  <option value="DEPOSIT">ຈ່າຍມັດຈຳ</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={8}>
              <Form.Group>
                <Form.Label>ຂົນສົ່ງ</Form.Label>
                <Form.Control
                  as="select"
                  name="logistic"
                  value={formData.logistic}
                  onChange={handleInputChange}
                >
                  <option value="">--ເລືອກ--</option>
                  <option value="HAL">ຮຸ່ງອາລຸນ</option>
                  <option value="ANOUSITH">ອານຸສິດ</option>
                  <option value="MIXAY">ມີໄຊ</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>ຊ່ອງທາງການຊຳລະ</Form.Label>
                <Form.Control
                  as="select"
                  name="payment"
                  value={formData.payment}
                  onChange={(e) => {
                    const nextPayment = e.target.value;
                    setFormData((prev) => ({
                      ...prev,
                      payment: nextPayment,
                      ...(nextPayment !== "TRANSFER" ? { paySlip: "" } : {}),
                    }));
                    if (nextPayment !== "TRANSFER") {
                      if (typeof paySlipPreviewSrc === "string" && paySlipPreviewSrc.startsWith("blob:")) {
                        try {
                          URL.revokeObjectURL(paySlipPreviewSrc);
                        } catch (_) {}
                      }
                      setPaySlipPreviewSrc("");
                    }
                  }}
                >
                  <option value="CASH">ເງິນສົດ</option>
                  <option value="TRANSFER">ເງິນໂອນ</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>{formData.paymentType === "DEPOSIT" ? "ຈຳນວນເງິນມັດຈຳ" : "ຮັບເງິນມາມູນຄ່າ"}</Form.Label>
                <NumericFormat
                  customInput={Form.Control}
                  name="receivedMoney"
                  value={formData.receivedMoney}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={0}
                  allowNegative={false}
                  onValueChange={(values) => {
                    setFormData((prev) => ({
                      ...prev,
                      receivedMoney: values.value,
                    }));
                  }}
                  placeholder={formData.paymentType === "DEPOSIT" ? "ປ້ອນເງິນມັດຈຳ" : "ປ້ອນຈຳນວນເງິນ"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>{formData.paymentType === "DEPOSIT" ? "ຍອດຄ້າງຊຳລະ" : "ເງິນທອນ"}</Form.Label>
                <Form.Control
                  type="number"
                  readOnly
                  value={formData.paymentType === "DEPOSIT" ? outstandingPreview : changePreview}
                />
              </Form.Group>
            </Col>
          </Row>

          {formData.payment === "TRANSFER" && (
            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>ສະລິບການໂອນ</Form.Label>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                    <Form.Control
                      ref={paySlipFileRef}
                      type="file"
                      accept="image/*"
                      onChange={handlePaySlipChange}
                      disabled={isUploadingPaySlip}
                      style={{ display: "none" }}
                    />
                    <Button
                      variant={formData.paySlip || paySlipPreviewSrc ? "outline-primary" : "primary"}
                      onClick={() => paySlipFileRef.current?.click()}
                      disabled={isUploadingPaySlip}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        borderRadius: 10,
                        padding: "8px 14px",
                        fontWeight: 700,
                      }}
                    >
                      <FaCamera />
                      {formData.paySlip || paySlipPreviewSrc ? "ປ່ຽນສະລິບ" : "ອັບໂຫຼດສະລິບ"}
                    </Button>
                    {paySlipPreviewSrc ? (
                      <div
                        style={{
                          width: 54,
                          height: 54,
                          borderRadius: 8,
                          border: "1px solid #e5e7eb",
                          overflow: "hidden",
                          background: "#fff",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setImagePreviewSrc(paySlipPreviewSrc);
                          setShowImagePreview(true);
                        }}
                      >
                        <img
                          src={paySlipPreviewSrc}
                          alt="payslip"
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      </div>
                    ) : null}
                    {formData.paySlip ? (
                      <span style={{ fontSize: 12, color: "#6b7280" }}>{formData.paySlip}</span>
                    ) : null}
                    {(formData.paySlip || paySlipPreviewSrc) ? (
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={removePaySlip}
                        disabled={isUploadingPaySlip}
                      >
                        ລຶບສະລິບ
                      </Button>
                    ) : null}
                    {isUploadingPaySlip ? (
                      <span style={{ fontSize: 12, color: "#6b7280" }}>ກຳລັງອັບໂຫຼດ...</span>
                    ) : null}
                  </div>
                </Form.Group>
              </Col>
            </Row>
          )}

          <Row className="mb-3">
            <Col md={12}>
              <Form.Group style={{ position: "relative" }}>
                <Form.Label>ເລືອກສິນຄ້າ (ສາມາດເລືອກໄດ້ຫຼາຍລາຍການ)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="ຄົ້ນຫາຊື່ສິນຄ້າເພື່ອເພີ່ມລົງໃນລາຍການ..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setShowDropdown(true);
                  }}
                  onFocus={() => setShowDropdown(true)}
                />
                {showDropdown && filteredProducts?.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      maxHeight: "200px",
                      overflowY: "auto",
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      zIndex: 1000,
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {filteredProducts.map((p) => (
                      <div
                        key={p.id}
                        style={{
                          padding: "10px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onClick={() => handleProductSelect(p)}
                      >
                        {p.name} {p.isPrinted === true || p.product?.isPrinted === true ? <span style={{ color: "green", fontSize: "12px", marginLeft: "8px" }}>(ງານພິມ)</span> : ""}
                      </div>
                    ))}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* ລາຍການສິນຄ້າທີ່ເລືອກແລ້ວ */}
          {selectedProducts.length > 0 && (
            <div className="mt-4">
              <h6 style={{ fontWeight: "bold", marginBottom: 15 }}>
                ລາຍການສິນຄ້າທີ່ເລືອກແລ້ວ ({selectedProducts.length})
              </h6>
              {selectedProducts.map((sp, index) => (
                <div
                  key={index}
                  style={{
                    background: "#f9fafb",
                    padding: 15,
                    borderRadius: 8,
                    marginBottom: 15,
                    position: "relative",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <Button
                    variant="outline-danger"
                    size="sm"
                    style={{ position: "absolute", top: 15, right: 15 }}
                    onClick={() => handleRemoveProduct(index)}
                  >
                    ລຶບ
                  </Button>
                  <h6
                    style={{
                      fontWeight: "bold",
                      marginBottom: 15,
                      paddingRight: "50px",
                      color: "#111827",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>{index + 1}. {sp.product.name}</span>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{ color: "#2563eb" }}>
                        ລາຄາ: {calculateProductPrice(sp).toLocaleString()}
                      </span>
                      <Form.Control
                        size="sm"
                        type="number"
                        min="0"
                        step="1"
                        value={sp.totalPriceOverride ?? ""}
                        onChange={(e) => handleProductChange(index, "totalPriceOverride", e.target.value)}
                        style={{ width: 160 }}
                        placeholder="ແກ້ໄຂລາຄາລວມ"
                      />
                      <Form.Control
                        size="sm"
                        type="number"
                        min="0"
                        step="1"
                        value={sp.discountAmount ?? ""}
                        onChange={(e) => handleProductChange(index, "discountAmount", e.target.value)}
                        style={{ width: 140 }}
                        placeholder="ສ່ວນຫຼຸດ"
                      />
                    </div>
                  </h6>
                  {Number((rewardSummary?.lineApplications || []).find((x) => x.index === index)?.amountFree || 0) > 0 && (
                    <div style={{ marginTop: -8, marginBottom: 10 }}>
                      <span
                        style={{
                          display: "inline-block",
                          padding: "2px 10px",
                          borderRadius: 999,
                          background: "#ecfdf5",
                          border: "1px solid #a7f3d0",
                          color: "#047857",
                          fontSize: 12,
                          fontWeight: 800,
                        }}
                      >
                        ແຖມ {Number((rewardSummary?.lineApplications || []).find((x) => x.index === index)?.amountFree || 0).toLocaleString()} ຊິ້ນ
                      </span>
                    </div>
                  )}

                  {sp.product.isPrinted ? (
                    <>
                      <Row className="mb-3">
                        <Col md={12}>
                          <Form.Group>
                            <Form.Label>ເລືອກຜ້າ</Form.Label>
                            <Form.Select
                              value={sp.fabricId}
                              onChange={(e) =>
                                handleProductChange(
                                  index,
                                  "fabricId",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">-- ເລືອກຜ້າ --</option>
                              {fabrics.map((f) => (
                                <option key={f.id} value={f.id}>
                                  {f.name} - ລາຄາ: {f.price}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>ໄຊຕ໌</Form.Label>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "15px" }}>
                            {shopSizes.map((sz) => {
                              const isSelected = sp.sizeQuantities.hasOwnProperty(sz.id);
                              return (
                                <div
                                  key={sz.id}
                                  onClick={() => toggleProductSize(index, sz.id)}
                                  style={{
                                    padding: "6px 16px",
                                    border: isSelected ? "1px solid #10b981" : "1px solid #d1d5db",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    backgroundColor: "white",
                                    color: isSelected ? "#374151" : "#6b7280",
                                    fontWeight: "normal",
                                    userSelect: "none"
                                  }}
                                >
                                  {isSelected && <FaCheckCircle style={{ fontSize: "14px", color: "#6b7280" }} />}
                                  {sz.value}
                                </div>
                              );
                            })}
                          </div>

                          {Object.keys(sp.sizeQuantities).length > 0 && (
                            <div style={{ backgroundColor: "#fff", padding: "15px", borderRadius: "8px", marginTop: "10px" }}>
                              <Form.Label style={{ fontWeight: "bold", color: "#6b7280", marginBottom: "12px" }}>ປ້ອນຈຳນວນແຕ່ລະໄຊຕ໌</Form.Label>
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                                {shopSizes
                                  .filter((sz) => sp.sizeQuantities.hasOwnProperty(sz.id))
                                  .map((sz) => (
                                    <div key={sz.id} style={{ display: "flex", flexDirection: "column", width: "120px" }}>
                                      <Form.Label style={{ fontSize: "13px", color: "#6b7280", marginBottom: "4px" }}>Size {sz.value}</Form.Label>
                                      <Form.Control
                                        type="number"
                                        min="0"
                                        placeholder="ປ້ອນຈຳນວນ.."
                                        value={sp.sizeQuantities[sz.id] === "" ? "" : sp.sizeQuantities[sz.id]}
                                        onChange={(e) =>
                                          handleProductSizeChange(
                                            index,
                                            sz.id,
                                            e.target.value
                                          )
                                        }
                                        style={{ fontSize: "14px" }}
                                      />
                                    </div>
                                  ))}
                              </div>
                            </div>
                          )}

                          {Number((rewardSummary?.lineApplications || []).find((x) => x.index === index)?.amountFree || 0) > 0 && (
                            <div style={{ marginTop: 10 }}>
                              <div
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 8,
                                  padding: "6px 10px",
                                  borderRadius: 999,
                                  background: "#ecfdf5",
                                  border: "1px solid #a7f3d0",
                                  color: "#047857",
                                  fontSize: 12,
                                  fontWeight: 900,
                                }}
                              >
                                ໄດ້ຮັບແຖມ {Number((rewardSummary?.lineApplications || []).find((x) => x.index === index)?.amountFree || 0).toLocaleString()} ຊິ້ນ
                              </div>
                            </div>
                          )}

                          {(Number((rewardSummary?.lineApplications || []).find((x) => x.index === index)?.amountFree || 0) > 0) && (
                            <div style={{ marginTop: 10, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, padding: 10 }}>
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                                <div style={{ fontSize: 12, fontWeight: 900, color: "#111827" }}>ລາຍການແຖມ (ປ້ອນໄຊ້/ຈຳນວນ)</div>
                                <Button
                                  type="button"
                                  size="sm"
                                  variant="outline-primary"
                                  onClick={() => addFreeGiftRow(index)}
                                >
                                  + ເພີ່ມ
                                </Button>
                              </div>

                              {(sp.freeGifts || []).length > 0 ? (
                                <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
                                  {(sp.freeGifts || []).map((row, rIdx) => (
                                    <div key={`${index}-gift-${rIdx}`} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                      <Form.Select
                                        value={row?.sizeId || ""}
                                        onChange={(e) => {
                                          const sizeId = e.target.value;
                                          const sizeLabel = shopSizes.find((s) => s.id === sizeId)?.value || "";
                                          updateFreeGiftRow(index, rIdx, { sizeId, size: sizeLabel });
                                        }}
                                        style={{ width: 140, height: 34 }}
                                      >
                                        <option value="">ໄຊ້</option>
                                        {shopSizes.map((sz) => (
                                          <option key={sz.id} value={sz.id}>{sz.value}</option>
                                        ))}
                                      </Form.Select>
                                      <Form.Control
                                        type="number"
                                        min="0"
                                        value={row?.qty ?? ""}
                                        onChange={(e) => updateFreeGiftRow(index, rIdx, { qty: e.target.value })}
                                        placeholder="ຈຳນວນ"
                                        style={{ width: 120, height: 34 }}
                                      />
                                      <Button
                                        type="button"
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={() => removeFreeGiftRow(index, rIdx)}
                                      >
                                        ລຶບ
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <div style={{ marginTop: 10, fontSize: 12, color: "#6b7280" }}>
                                  ກະລຸນາເພີ່ມລາຍການແຖມ
                                </div>
                              )}
                            </div>
                          )}

                          <div style={{ marginTop: 10 }}>
                            <div style={{ fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>
                              ອັບໂຫຼດອົງປະກອບ
                            </div>
                            <div
                              style={{
                                border: "1px dashed #d1d5db",
                                background: "#f9fafb",
                                borderRadius: 12,
                                padding: 12,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 12,
                                flexWrap: "wrap",
                              }}
                            >
                              <input
                                id={`element-upload-input-${index}`}
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={(e) => handleElementImageChange(index, e)}
                                disabled={sp.isUploadingElementImages}
                                style={{ display: "none" }}
                              />
                              <label
                                htmlFor={`element-upload-input-${index}`}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 8,
                                  padding: "10px 12px",
                                  borderRadius: 10,
                                  border: "1px solid #e5e7eb",
                                  background: sp.isUploadingElementImages ? "#f3f4f6" : "#ffffff",
                                  color: sp.isUploadingElementImages ? "#9ca3af" : "#111827",
                                  cursor: sp.isUploadingElementImages ? "not-allowed" : "pointer",
                                  fontSize: 13,
                                  fontWeight: 800,
                                  userSelect: "none",
                                }}
                              >
                                <FaCamera style={{ fontSize: 14 }} />
                                ເລືອກຮູບ
                              </label>

                              <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                                {sp.isUploadingElementImages ? (
                                  <span style={{ fontSize: 12, color: "#6b7280", fontWeight: 700 }}>ກຳລັງອັບໂຫຼດ...</span>
                                ) : (
                                  <>
                                    <span style={{ fontSize: 12, color: "#6b7280" }}>
                                      {(sp.elementImages || []).length} ຮູບ
                                    </span>
                                    <span style={{ fontSize: 12, color: "#9ca3af" }}>
                                      ກົດຮູບເພື່ອເບິ່ງໃຫຍ່
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>

                            {(sp.elementImages || []).length > 0 && (
                              <div
                                style={{
                                  marginTop: 10,
                                  display: "grid",
                                  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                                  gap: 8,
                                }}
                              >
                                {(sp.elementImages || []).map((img, imgIndex) => {
                                  const src = img?.previewSrc;
                                  return (
                                    <div key={`${img?.image || "img"}-${imgIndex}`} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                      <div
                                        style={{
                                          width: 80,
                                          height: 80,
                                          borderRadius: 8,
                                          border: "1px solid #e5e7eb",
                                          overflow: "hidden",
                                          position: "relative",
                                          background: "#fff",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setImagePreviewSrc(src);
                                          setShowImagePreview(true);
                                        }}
                                      >
                                        <img
                                          src={src}
                                          alt="element"
                                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        />
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            removeElementImage(index, imgIndex);
                                          }}
                                          disabled={sp.isUploadingElementImages}
                                          style={{
                                            position: "absolute",
                                            top: 4,
                                            right: 4,
                                            width: 20,
                                            height: 20,
                                            borderRadius: 999,
                                            border: "1px solid #e5e7eb",
                                            background: "#ffffff",
                                            color: "#111827",
                                            cursor: sp.isUploadingElementImages ? "not-allowed" : "pointer",
                                            padding: 0,
                                            lineHeight: "18px",
                                            fontWeight: 900,
                                          }}
                                        >
                                          ×
                                        </button>
                                      </div>
                                      <input
                                        value={img?.detail || ""}
                                        onChange={(e) => {
                                          updateElementImageDetail(index, imgIndex, e.target.value);
                                        }}
                                        placeholder="ປ້ອນລາຍລະອຽດ (ບໍ່ບັງຄັບ)"
                                        disabled={sp.isUploadingElementImages}
                                        style={{
                                          width: 120,
                                          height: 30,
                                          padding: "0 8px",
                                          borderRadius: 8,
                                          border: "1px solid #e5e7eb",
                                          background: sp.isUploadingElementImages ? "#f3f4f6" : "#ffffff",
                                          fontSize: 12,
                                          outline: "none",
                                        }}
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label>ຈຳນວນ</Form.Label>
                            <Form.Control
                              type="number"
                              min="1"
                              value={sp.quantity}
                              onChange={(e) =>
                                handleProductChange(
                                  index,
                                  "quantity",
                                  parseInt(e.target.value) || 1
                                )
                              }
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      {Number((rewardSummary?.lineApplications || []).find((x) => x.index === index)?.amountFree || 0) > 0 && (
                        <div style={{ marginTop: 10 }}>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 8,
                              padding: "6px 10px",
                              borderRadius: 999,
                              background: "#ecfdf5",
                              border: "1px solid #a7f3d0",
                              color: "#047857",
                              fontSize: 12,
                              fontWeight: 900,
                            }}
                          >
                            ໄດ້ຮັບແຖມ {Number((rewardSummary?.lineApplications || []).find((x) => x.index === index)?.amountFree || 0).toLocaleString()} ຊິ້ນ
                          </div>
                        </div>
                      )}

                      {(Number((rewardSummary?.lineApplications || []).find((x) => x.index === index)?.amountFree || 0) > 0) && (
                        <div style={{ marginTop: 10, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, padding: 10 }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                            <div style={{ fontSize: 12, fontWeight: 900, color: "#111827" }}>ລາຍການແຖມ (ປ້ອນໄຊ້/ຈຳນວນ)</div>
                            <Button
                              type="button"
                              size="sm"
                              variant="outline-primary"
                              onClick={() => addFreeGiftRow(index)}
                            >
                              + ເພີ່ມ
                            </Button>
                          </div>

                          {(sp.freeGifts || []).length > 0 ? (
                            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
                              {(sp.freeGifts || []).map((row, rIdx) => (
                                <div key={`${index}-gift-${rIdx}`} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                  <Form.Select
                                    value={row?.sizeId || ""}
                                    onChange={(e) => {
                                      const sizeId = e.target.value;
                                      const sizeLabel = shopSizes.find((s) => s.id === sizeId)?.value || "";
                                      updateFreeGiftRow(index, rIdx, { sizeId, size: sizeLabel });
                                    }}
                                    style={{ width: 140, height: 34 }}
                                  >
                                    <option value="">ໄຊ້</option>
                                    {shopSizes.map((sz) => (
                                      <option key={sz.id} value={sz.id}>{sz.value}</option>
                                    ))}
                                  </Form.Select>
                                  <Form.Control
                                    type="number"
                                    min="0"
                                    value={row?.qty ?? ""}
                                    onChange={(e) => updateFreeGiftRow(index, rIdx, { qty: e.target.value })}
                                    placeholder="ຈຳນວນ"
                                    style={{ width: 120, height: 34 }}
                                  />
                                  <Button
                                    type="button"
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={() => removeFreeGiftRow(index, rIdx)}
                                  >
                                    ລຶບ
                                  </Button>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div style={{ marginTop: 10, fontSize: 12, color: "#6b7280" }}>
                              ກະລຸນາເພີ່ມລາຍການແຖມ
                            </div>
                          )}
                        </div>
                      )}

                      <div style={{ marginTop: 10 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>
                          ອັບໂຫຼດອົງປະກອບ
                        </div>
                        <div
                          style={{
                            border: "1px dashed #d1d5db",
                            background: "#f9fafb",
                            borderRadius: 12,
                            padding: 12,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 12,
                            flexWrap: "wrap",
                          }}
                        >
                          <input
                            id={`element-upload-input-${index}`}
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={(e) => handleElementImageChange(index, e)}
                            disabled={sp.isUploadingElementImages}
                            style={{ display: "none" }}
                          />
                          <label
                            htmlFor={`element-upload-input-${index}`}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 8,
                              padding: "10px 12px",
                              borderRadius: 10,
                              border: "1px solid #e5e7eb",
                              background: sp.isUploadingElementImages ? "#f3f4f6" : "#ffffff",
                              color: sp.isUploadingElementImages ? "#9ca3af" : "#111827",
                              cursor: sp.isUploadingElementImages ? "not-allowed" : "pointer",
                              fontSize: 13,
                              fontWeight: 800,
                              userSelect: "none",
                            }}
                          >
                            <FaCamera style={{ fontSize: 14 }} />
                            ເລືອກຮູບ
                          </label>

                          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                            {sp.isUploadingElementImages ? (
                              <span style={{ fontSize: 12, color: "#6b7280", fontWeight: 700 }}>ກຳລັງອັບໂຫຼດ...</span>
                            ) : (
                              <>
                                <span style={{ fontSize: 12, color: "#6b7280" }}>
                                  {(sp.elementImages || []).length} ຮູບ
                                </span>
                                <span style={{ fontSize: 12, color: "#9ca3af" }}>
                                  ກົດຮູບເພື່ອເບິ່ງໃຫຍ່
                                </span>
                              </>
                            )}
                          </div>
                        </div>

                        {(sp.elementImages || []).length > 0 && (
                          <div
                            style={{
                              marginTop: 10,
                              display: "grid",
                              gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                              gap: 8,
                            }}
                          >
                            {(sp.elementImages || []).map((img, imgIndex) => {
                              const src = img?.previewSrc;
                              return (
                                <div key={`${img?.image || "img"}-${imgIndex}`} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                  <div
                                    style={{
                                      width: 80,
                                      height: 80,
                                      borderRadius: 8,
                                      border: "1px solid #e5e7eb",
                                      overflow: "hidden",
                                      position: "relative",
                                      background: "#fff",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setImagePreviewSrc(src);
                                      setShowImagePreview(true);
                                    }}
                                  >
                                    <img
                                      src={src}
                                      alt="element"
                                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        removeElementImage(index, imgIndex);
                                      }}
                                      disabled={sp.isUploadingElementImages}
                                      style={{
                                        position: "absolute",
                                        top: 4,
                                        right: 4,
                                        width: 20,
                                        height: 20,
                                        borderRadius: 999,
                                        border: "1px solid #e5e7eb",
                                        background: "#ffffff",
                                        color: "#111827",
                                        cursor: sp.isUploadingElementImages ? "not-allowed" : "pointer",
                                        padding: 0,
                                        lineHeight: "18px",
                                        fontWeight: 900,
                                      }}
                                    >
                                      ×
                                    </button>
                                  </div>
                                  <input
                                    value={img?.detail || ""}
                                    onChange={(e) => {
                                      updateElementImageDetail(index, imgIndex, e.target.value);
                                    }}
                                    placeholder="ປ້ອນລາຍລະອຽດ (ບໍ່ບັງຄັບ)"
                                    disabled={sp.isUploadingElementImages}
                                    style={{
                                      width: 120,
                                      height: 30,
                                      padding: "0 8px",
                                      borderRadius: 8,
                                      border: "1px solid #e5e7eb",
                                      background: sp.isUploadingElementImages ? "#f3f4f6" : "#ffffff",
                                      fontSize: 12,
                                      outline: "none",
                                    }}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  <Row className="mt-3">
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>ລາຍລະເອີຍດເພີ່ມເຕີມ</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="ປ້ອນລາຍລະອຽດເພີ່ມເຕີມ..."
                          value={sp.orderDetail}
                          onChange={(e) =>
                            handleProductChange(index, "orderDetail", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              ))}

              <div
                style={{
                  background: "#eef2ff",
                  padding: "15px 20px",
                  borderRadius: 8,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "20px",
                  border: "1px solid #c7d2fe",
                }}
              >
                <h5 style={{ margin: 0, fontWeight: "bold", color: "#1e40af" }}>
                  ລວມມູນຄ່າທັງໝົດ:
                </h5>
                <h4 style={{ margin: 0, fontWeight: "bold", color: "#1d4ed8" }}>
                  {Math.max(calculateTotalOrderPrice() - (Number(rewardSummary.discountAmount || 0) || 0), 0).toLocaleString()} ກີບ
                </h4>
              </div>

              {(rewardsLoading || rewardSummary.eligible.length > 0 || rewardSummary.notYet.length > 0) && (
                <div
                  style={{
                    marginTop: 12,
                    background: "#ffffff",
                    border: "1px solid #e5e7eb",
                    borderRadius: 10,
                    padding: 12,
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                    <div style={{ fontWeight: 900, color: "#111827" }}>ລາງວັນ (Reward)</div>
                    <div style={{ fontSize: 12, color: "#6b7280" }}>
                      {rewardsLoading
                        ? "ກຳລັງໂຫຼດ..."
                        : `ກ່ຽວຂ້ອງ ${(rewardSummary.eligible.length + rewardSummary.notYet.length).toLocaleString()} | ເຂົ້າເງື່ອນໄຂ ${rewardSummary.eligible.length.toLocaleString()}`}
                    </div>
                  </div>

                  {rewardSummary.eligible.length > 0 && (
                    <div style={{ marginTop: 10 }}>
                      <div style={{ fontSize: 12, fontWeight: 800, color: "#065f46", marginBottom: 6 }}>
                        ເຂົ້າເງື່ອນໄຂ
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 8 }}>
                        {rewardSummary.eligible.map(({ reward, qty, amount, minQty, minAmount, applyType }) => (
                          <div
                            key={reward?.id}
                            style={{
                              border: "1px solid #d1fae5",
                              background: "#ecfdf5",
                              borderRadius: 10,
                              padding: 10,
                            }}
                          >
                            <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                              <div style={{ fontWeight: 900, color: "#064e3b" }}>{reward?.name || "-"}</div>
                              <div style={{ fontSize: 12, color: "#065f46", fontWeight: 800 }}>
                                {reward?.rewardType === "DISCOUNT"
                                  ? "ສ່ວນຫຼຸດ"
                                  : reward?.rewardType === "ITEM"
                                  ? "ສິນຄ້າ"
                                  : reward?.rewardType === "FREE_SHIPPING"
                                  ? "ສົ່ງຟຣີ"
                                  : (reward?.rewardType || "-")}
                              </div>
                            </div>
                            <div style={{ marginTop: 6, fontSize: 12, color: "#047857" }}>
                              {applyType === "SPECIFIC_PRODUCTS"
                                ? "ເງື່ອນໄຂ: ສະເພາະສິນຄ້າ"
                                : applyType === "SPECIFIC_CATEGORIES"
                                ? "ເງື່ອນໄຂ: ສະເພາະໝວດໝູ່"
                                : "ເງື່ອນໄຂ: ທັງໝົດ"}
                              {(minQty > 0 || minAmount > 0) ? " | " : ""}
                              {minQty > 0 ? `ຈຳນວນ ${qty}/${minQty}` : ""}
                              {minQty > 0 && minAmount > 0 ? " | " : ""}
                              {minAmount > 0 ? `ຍອດ ${Number(amount || 0).toLocaleString()}/${Number(minAmount || 0).toLocaleString()}` : ""}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {rewardSummary.notYet.length > 0 && (
                    <div style={{ marginTop: 10 }}>
                      <div style={{ fontSize: 12, fontWeight: 800, color: "#92400e", marginBottom: 6 }}>
                        ກ່ຽວຂ້ອງ (ຍັງບໍ່ຄົບເງື່ອນໄຂ)
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 8 }}>
                        {rewardSummary.notYet.map(({ reward, qty, amount, minQty, minAmount, applyType, isActive, inactiveReason }) => (
                          <div
                            key={reward?.id}
                            style={{
                              border: "1px solid #fde68a",
                              background: "#fffbeb",
                              borderRadius: 10,
                              padding: 10,
                            }}
                          >
                            <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                              <div style={{ fontWeight: 900, color: "#78350f" }}>{reward?.name || "-"}</div>
                              <div style={{ fontSize: 12, color: "#92400e", fontWeight: 800 }}>
                                {reward?.rewardType === "DISCOUNT"
                                  ? "ສ່ວນຫຼຸດ"
                                  : reward?.rewardType === "ITEM"
                                  ? "ສິນຄ້າ"
                                  : reward?.rewardType === "FREE_SHIPPING"
                                  ? "ສົ່ງຟຣີ"
                                  : (reward?.rewardType || "-")}
                              </div>
                            </div>
                            <div style={{ marginTop: 6, fontSize: 12, color: "#92400e" }}>
                              {!isActive && inactiveReason ? `${inactiveReason} | ` : ""}
                              {applyType === "SPECIFIC_PRODUCTS"
                                ? "ເງື່ອນໄຂ: ສະເພາະສິນຄ້າ"
                                : applyType === "SPECIFIC_CATEGORIES"
                                ? "ເງື່ອນໄຂ: ສະເພາະໝວດໝູ່"
                                : "ເງື່ອນໄຂ: ທັງໝົດ"}
                              {(minQty > 0 || minAmount > 0) ? " | " : ""}
                              {minQty > 0 ? `ຈຳນວນ ${qty}/${minQty}` : ""}
                              {minQty > 0 && minAmount > 0 ? " | " : ""}
                              {minAmount > 0 ? `ຍອດ ${Number(amount || 0).toLocaleString()}/${Number(minAmount || 0).toLocaleString()}` : ""}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {(rewardSummary.totalFreeQty > 0 || rewardSummary.discountAmount > 0) && (
                    <div
                      style={{
                        marginTop: 10,
                        borderTop: "1px dashed #e5e7eb",
                        paddingTop: 10,
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 12,
                        flexWrap: "wrap",
                        fontSize: 12,
                        color: "#374151",
                        fontWeight: 700,
                      }}
                    >
                      <span>ລວມຂອງແຖມ: {Number(rewardSummary.totalFreeQty || 0).toLocaleString()} ຊິ້ນ</span>
                      <span>ສ່ວນຫຼຸດລວມ: {Number(rewardSummary.discountAmount || 0).toLocaleString()} ກີບ</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={creatingOrder}>
          ຍົກເລີກ
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={creatingOrder || isElementImagesUploading || isUploadingPaySlip}>
          {creatingOrder ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກອໍເດີ"}
        </Button>
      </Modal.Footer>
      <CreateCustomerModal
        show={showCreateCustomerModal}
        onHide={() => setShowCreateCustomerModal(false)}
        shopId={shopId}
        onCustomerCreated={(newCustomer) => {
          setSelectedCustomer(newCustomer);
          setCustomerSearchTerm(`${newCustomer.name || ""} ${newCustomer.lastname || ""}`.trim());
          setFormData({
            ...formData,
            firstName: newCustomer.name || "",
            lastName: newCustomer.lastname || "",
            phone: newCustomer.phone || "",
            province: newCustomer.address?.province || "",
            district: newCustomer.address?.district || "",
            village: newCustomer.address?.village || "",
          });
        }}
      />
      </Modal>

      <Modal show={showImagePreview} onHide={() => setShowImagePreview(false)} size="lg" centered>
        <Modal.Body style={{ padding: 10, background: "#111827" }}>
          {imagePreviewSrc ? (
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <img
                src={imagePreviewSrc}
                alt="preview"
                style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: 8 }}
              />
            </div>
          ) : null}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreateOrderModal;
